// src/jira/project-category/types.ts
var JiraProjectCategoryAriResourceOwner = "jira", JiraProjectCategoryAriResourceType = "project-category";

export {
  JiraProjectCategoryAriResourceOwner,
  JiraProjectCategoryAriResourceType
};
